<template>
  <button
    class="flex w-full h-full px-[20px] md:px-[24px] lg:px-[28px] py-[16px] md:py-[18px] lg:py-[20px] rounded-[10px] text-left items-start cursor-pointer transition-colors"
    :class="{
      'bg-[#E5E2DF]': isPendingRemoval,
      'border border-solid border-[#a5a4a3] hover:bg-[#F6F4F0]': !isPendingRemoval,
    }"
    @click="handleClick"
  >
    <div class="flex flex-col flex-1 gap-[16px] md:gap-[18px] lg:gap-[20px]">
      <div class="flex items-center gap-[16px] md:gap-[18px] lg:gap-[20px] w-full">
        <div class="flex flex-col gap-[4px] md:gap-[6px] lg:gap-[8px] flex-1">
          <div
            class="text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.5rem] md:leading-[2rem] lg:leading-[2.25rem] font-inter font-medium text-[#21201E]"
          >
            {{ title }}
          </div>
          <div
            class="text-[0.875rem] md:text-[1.375rem] lg:text-[1.5rem] leading-[1.25rem] md:leading-[1.75rem] lg:leading-[2rem] font-inter font-normal text-[#373531]"
          >
            {{ bankAccount }}
          </div>
          <div class="flex gap-[8px] md:gap-[10px] lg:gap-[12px] items-center">
            <img
              src="assets/icons/my-giving/recurring.svg"
              alt="Recurring"
              class="w-[16px] h-[16px] md:w-[20px] md:h-[20px] lg:w-[24px] lg:h-[24px] shrink-0"
            />
            <p
              class="text-[0.75rem] md:text-[1.25rem] lg:text-[1.375rem] leading-[1rem] md:leading-[1.5rem] lg:leading-[1.75rem] font-inter font-normal text-[#373531]"
            >
              {{ frequency }}
            </p>
          </div>
        </div>
        <img
          v-if="showChevron"
          src="/assets/icons/my-giving/chevronRight.svg"
          alt="Chevron"
          class="w-[24px] h-[24px] md:w-[28px] md:h-[28px] lg:w-[32px] lg:h-[32px] shrink-0"
        />
      </div>
      <div class="flex items-center gap-[20px] md:gap-[24px] lg:gap-[28px] w-full">
        <div
          v-if="nextGivingDate"
          class="text-[0.75rem] md:text-[1.25rem] lg:text-[1.375rem] leading-[1rem] md:leading-[1.5rem] lg:leading-[1.75rem] font-inter font-normal text-[#63615E]"
        >
          Next giving on {{ nextGivingDate }}
        </div>
        <div v-else class="flex-1"></div>
        <p class="flex-1 text-right">
          <span
            class="text-[0.75rem] md:text-[1.25rem] lg:text-[1.375rem] leading-[1rem] md:leading-[1.5rem] lg:leading-[1.75rem] font-inter font-normal text-[#373531]"
            >$</span
          >
          <span
            class="text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.5rem] md:leading-[2rem] lg:leading-[2.25rem] font-inter font-bold text-[#373531]"
            >{{ formattedAmount }}</span
          >
        </p>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'RadioItem',
  props: {
    title: String,
    bankAccount: String,
    frequency: String,
    amount: [String, Number],
    nextGivingDate: String,
    isPendingRemoval: {
      type: Boolean,
      default: false,
    },
    showChevron: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedAmount() {
      if (!this.amount) return '0.00';
      const numAmount = typeof this.amount === 'string' ? parseFloat(this.amount) : this.amount;
      return numAmount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  methods: {
    handleClick() {
      if (!this.isPendingRemoval) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style scoped></style>
